<template>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="tab-Meals" @click="gotoMeals">
      <ion-icon name="list-box" mode="ios" :class="mealsClass"></ion-icon>
      <span class="text-sm" :class="mealsClass">Refeições</span>
    </ion-tab-button>
    <ion-tab-button tab="tab-ShoppingList" @click="gotoShoppingList">
      <ion-icon name="basket" mode="ios" :class="shoppingClass"></ion-icon>
      <span class="text-sm" :class="shoppingClass">Compras</span>
    </ion-tab-button>
    <ion-tab-button tab="tab-ProfilePage" @click="gotoProfilePage">
      <ion-icon name="person" mode="ios" :class="profileClass"></ion-icon>
      <span class="text-sm" :class="profileClass">Perfil</span>
    </ion-tab-button>
    <ion-tab-button tab="tab-RecipeBook" @click="gotoRecipeBook">
      <ion-icon name="bookmarks" mode="ios" :class="recipesClass"></ion-icon>
      <span class="text-sm" :class="recipesClass">Receitas</span>
    </ion-tab-button>
  </ion-tab-bar>
</template>

<script>
export default {
  name: "TabBar",
  props: {
    mealsClass: String,
    shoppingClass: String,
    profileClass: String,
    recipesClass: String
  },
  methods: {
    gotoMeals() {
      this.$router.push({
        name: "Meal Plan"
      });
    },
    gotoShoppingList() {
      this.$router.push({
        name: "Shopping List"
      });
    },
    gotoProfilePage() {
      this.$router.push({
        name: "Profile"
      });
    },
    gotoRecipeBook() {
      this.$router.push("/recipes");
    }
  }
};
</script>

<style scoped>
ion-tab-bar {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
.tab-green {
  color: var(--ion-color-primary) !important;
}
</style>
